import AppConstants from '../appConstants';
import moment from 'moment';

class ConvertDateTimeHelper {

  convertEpochToDate(epochDate) {
    // Used to Convert an epoch to human readable date:
    // https://www.epochconverter.com/
    // https://www.epochconverter.com/programming/#javascript
    const date = new Date(epochDate * 1000);
    let day = date.getUTCDate().toString();
    let month = (date.getUTCMonth() + 1).toString();
    const year = date.getFullYear().toString();

    if (date.getUTCDate() < 10) {
      day = '0' + date.getUTCDate();
    }
    if ((date.getUTCMonth() + 1) < 10) {
      month = '0' + (date.getUTCMonth() + 1);
    }

    return `${day}/${month}/${year}`;
  }

  convertEpochToDateTime(epochDate) {

    const date = new Date(epochDate * 1000);
    // console.log('convertEpochToDateTime ==> ',date);

    let day = date.getUTCDate().toString();
    let month = (date.getUTCMonth() + 1).toString();
    const year = date.getFullYear().toString();

    let hour = date.getUTCHours().toString();
    let minute = date.getUTCMinutes().toString();
    let second = date.getUTCSeconds().toString();

    if (date.getUTCDate() < 10) {
      day = '0' + date.getUTCDate();
    }
    if ((date.getUTCMonth() + 1) < 10) {
      month = '0' + (date.getUTCMonth() + 1);
    }

    if (date.getUTCHours() < 10) {
      hour = '0' + date.getUTCHours().toString();
    }
    if (date.getUTCMinutes() < 10) {
      minute = '0' + date.getUTCMinutes().toString();
    }
    if (date.getUTCSeconds() < 10) {
      second = '0' + date.getUTCSeconds().toString();
    }

    return `${day}/${month}/${year} ${hour}:${minute}:${second}`;
  }

  convertEpochToDateTimeObject(epochDate) {

    if (!epochDate) {
      return {
        day: '',
        month: '',
        year: '',
        hour: '',
        minute: '',
        second: ''
      };
    }

    const date = new Date(epochDate * 1000);
    // console.log('convertEpochToDateTime ==> ',date);

    let day = date.getUTCDate().toString();
    let month = (date.getUTCMonth() + 1).toString();
    const year = date.getFullYear().toString();

    let hour = date.getUTCHours().toString();
    let minute = date.getUTCMinutes().toString();
    let second = date.getUTCSeconds().toString();

    if (date.getUTCDate() < 10) {
      day = '0' + date.getUTCDate();
    }
    if ((date.getUTCMonth() + 1) < 10) {
      month = '0' + (date.getUTCMonth() + 1);
    }

    if (date.getUTCHours() < 10) {
      hour = '0' + date.getUTCHours().toString();
    }
    if (date.getUTCMinutes() < 10) {
      minute = '0' + date.getUTCMinutes().toString();
    }
    if (date.getUTCSeconds() < 10) {
      second = '0' + date.getUTCSeconds().toString();
    }

    return {
      day: day,
      month: month,
      year: year,
      hour: hour,
      minute: minute,
      second: second
    };
  }

  convertEpochToDateObject(epochDate) {
    return new Date(epochDate * 1000);
  }

  convertEpochToDateObjectOffset(epochTime) {
    const dt = new Date(epochTime);
    return new Date(dt.getTime() + dt.getTimezoneOffset() * 60000);
  }

  convertEpochToFormattedDate(epochTime, locale) {
    const dt = new Date(epochTime);
    return dt.toLocaleDateString(locale) + ' ' + dt.toLocaleTimeString(locale);
  }

  convertSecondToHour(secs) {
    const hours = Math.floor(secs / (60 * 60));

    const divisor_for_minutes = secs % (60 * 60);
    const minutes = Math.floor(divisor_for_minutes / 60);

    const divisor_for_seconds = divisor_for_minutes % 60;
    const seconds = Math.ceil(divisor_for_seconds);

    let h = hours.toString();
    let m = minutes.toString();
    let s = seconds.toString();

    if (hours < 10) {
      h = '0' + hours;
    }
    if (minutes < 10) {
      m = '0' + minutes;
    }
    if (seconds < 10) {
      s = '0' + seconds;
    }

    return {
      'hours': h,
      'minutes': m,
      'seconds': s
    };
  }

  convertHourToSecond(hour) {
    // hour needs to be this format -> HH:MM
    const a = hour.split(':'); // split it at the colons

    // minutes are worth 60 seconds. Hours are worth 60 minutes.
    return ((+a[0]) * (60 * 60)) + ((+a[1]) * 60);
  }

  convertDateToEpoch(date) {
    if (!date) {
      return '';
    }

    const myDate = new Date(date);
    return myDate.getTime() / 1000.0;
  }

  convertEpochToDateInter(epochDate) {
    const date = new Date(epochDate * 1000);
    let day = date.getUTCDate().toString();
    let month = (date.getUTCMonth() + 1).toString();
    const year = date.getFullYear().toString();

    if (date.getUTCDate() < 10) {
      day = '0' + date.getUTCDate();
    }
    if ((date.getUTCMonth() + 1) < 10) {
      month = '0' + (date.getUTCMonth() + 1);
    }

    return `${year}/${month}/${day}`;
  }

  convertDateToStringFormatReport(dt) {
    const date = new Date(dt);
    let day = date.getUTCDate().toString();
    let month = (date.getUTCMonth() + 1).toString();
    const year = date.getFullYear().toString();

    if (date.getUTCDate() < 10) {
      day = '0' + date.getUTCDate();
    }
    if ((date.getUTCMonth() + 1) < 10) {
      month = '0' + (date.getUTCMonth() + 1);
    }

    return `${day}/${month}/${year}`;
  }

  convertDateToStringFormat(dt) {
    const date = new Date(dt);
    let day = date.getUTCDate().toString();
    let month = (date.getUTCMonth() + 1).toString();
    const year = date.getFullYear().toString();

    if (date.getUTCDate() < 10) {
      day = '0' + date.getUTCDate();
    }
    if ((date.getUTCMonth() + 1) < 10) {
      month = '0' + (date.getUTCMonth() + 1);
    }

    return `${day}${month}${year}`;
  }

  convertDateToStringFormatFrom(dt) {
    const date = new Date(dt);
    let day = date.getUTCDate().toString();
    let month = (date.getUTCMonth() + 1).toString();
    const year = date.getFullYear().toString();

    if (date.getUTCDate() < 10) {
      day = '0' + date.getUTCDate();
    }
    if ((date.getUTCMonth() + 1) < 10) {
      month = '0' + (date.getUTCMonth() + 1);
    }

    return `${year}-${month}-${day}T00:00:00`;
  }

  convertDateToStringFormatTo(dt) {
    const date = new Date(dt);
    let day = date.getUTCDate().toString();
    let month = (date.getUTCMonth() + 1).toString();
    const year = date.getFullYear().toString();

    if (date.getUTCDate() < 10) {
      day = '0' + date.getUTCDate();
    }
    if ((date.getUTCMonth() + 1) < 10) {
      month = '0' + (date.getUTCMonth() + 1);
    }

    return `${year}-${month}-${day}T23:59:59`;
  }

  getFilterDateParams(option) {
    const date = new Date();
    switch (option) {
      case AppConstants.FILTER_DATE_OPTION.One_Day:
        date.setDate(date.getDate() - 1);
        return this.convertDateToStringFormatFrom(date);
      case AppConstants.FILTER_DATE_OPTION.One_Week:
        date.setDate(date.getDate() - 7);
        return this.convertDateToStringFormatFrom(date);
      case AppConstants.FILTER_DATE_OPTION.One_Month:
        date.setMonth(date.getMonth() - 1);
        return this.convertDateToStringFormatFrom(date);
      case AppConstants.FILTER_DATE_OPTION.Three_Month:
        date.setMonth(date.getMonth() - 3);
        return this.convertDateToStringFormatFrom(date);
    }
    return '';
  }
  getTickerDate(value) {
    if (!value) return value;

    const valueMoment = moment(value);
    const isToday = valueMoment.isSame(new Date(), "day");
    if (isToday) {
      return this.getTimeShort(value);
    }
    return this.formatFullDate(value, { dateStyle: "short", timeStyle: "short" });
  }
  getTimeShort(value) {
    if (!value) return value;
    const formatting = { timeStyle: "short" }

    let dtString = new Intl.DateTimeFormat('pt-BR', formatting).format(new Date(value));
    return dtString.replace(',', '');
  }
  formatFullDate(value, formatting = { month: 'short', day: 'numeric', year: 'numeric' }) {
    if (!value) return value;

    let dtString = new Intl.DateTimeFormat('pt-BR', formatting).format(this.getDateWithoutTimezone(value));
    return dtString.replace(',', '');
  }
  formatFullDateTimezone(value, formatting = { month: 'short', day: 'numeric', year: 'numeric' }) {
    if (!value) return value;

    let dtString = new Intl.DateTimeFormat('pt-BR', formatting).format(new Date(value));
    return dtString.replace(',', '');
  }
  formatDate(value, formatting = { month: 'short', day: 'numeric', year: 'numeric' }) {
    if (!value) return value;

    const valueMoment = moment(value);
    const isToday = valueMoment.isSame(new Date(), "day");

    if (isToday) {
      return valueMoment.fromNow();
    } else {
      return this.formatFullDate(value, formatting);
    }
  }
  getDateWithoutTimezone(val) {
    let dtIso = new Date();
    if (val) {
      dtIso = new Date(val);
    }
    let dt = new Date(dtIso.toISOString().slice(0, -1));
    return dt;
  }

  convertDateToTime(dt) {
    const date = new Date(dt);
    const hour = ('0' + date.getUTCHours()).slice(-2);
    const minutes = ('0' + date.getUTCMinutes()).slice(-2);
    return hour + ':' + minutes;
  }
}

export default new ConvertDateTimeHelper();